export const PLAID_ACTION_TYPE = {
	// PLAID SUCCESS MESSAGES
	plaidCreateFetchSucess: "Verification Link Generated Successfully",
	plaidGetUploadFetchSucess: "User Verified Successfully",
	PlaidPictureUploadingMessage: "You Have Successfully Verified,Wait For Uploading Don't Reload The Page",
	// PLAID OTHER VARIABLES

	// REDUCER TYPES
	plaidCreate: "plaidCreate",
	plaidGetUpload: "plaidGetUpload",

	// RESETREDUCER TYPES
	plaidCreateIdle: "plaidCreateIdle",
	plaidGetUploadIdle: "plaidGetUploadIdle",

	// BANK ACCOUNT LINKING (Plaid flow)
	bankLinkTokenSuccess: "bankLinkTokenSuccess",
	bankLinkTokenError: "bankLinkTokenError",
	bankLinkTokenIdle: "bankLinkTokenIdle",
	bankExchangeSuccess: "bankExchangeSuccess",
	bankExchangeError: "bankExchangeError",
	bankExchangeIdle: "bankExchangeIdle",

	// BANK ACCOUNT LINKING (Stripe-native flow)
	bankSetupIntentSuccess: "bankSetupIntentSuccess",
	bankSetupIntentError: "bankSetupIntentError",
	bankSetupIntentIdle: "bankSetupIntentIdle",
	bankConfirmSuccess: "bankConfirmSuccess",
	bankConfirmError: "bankConfirmError",
	bankConfirmIdle: "bankConfirmIdle",
};
